<div class="header">
    <h2>Modifica <strong>Ordinativo</strong></h2>
    <div class="breadcrumb-wrapper hidden-xs">
        <ol class="breadcrumb">
            <li><a routerLink="/inspection-general">Gestione Ispezioni</a></li>
            <li><a [routerLink]="'/inspection/' + inspectionOrder.fk_id_inspection">Dettaglio Ispezione</a></li>
            <li><a [routerLink]="'/inspection/order/' + inspectionOrder.id_inspection_order">Dettaglio Ordinativo</a></li>
            <li class="active">Modifica Ordinativo</li>
        </ol>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 portlets">
        <div class="panel">
            <div class="panel-content" style="padding-top: 40px; padding-bottom: 40px;">
                <form (ngSubmit)="onSubmit()" #inspectionOrderUpdateForm="ngForm" role="form" class="form-horizontal form-validation">
                    <div class="form-group">
                        <label for="number" class="col-sm-3 control-label">Numero *</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="number"
                                   id="number"
                                   name="number"
                                   class="form-control"
                                   placeholder="Inserisci Numero..."
                                   minlength="3"
                                   required
                                   autocomplete="off"
                                   [ngClass]="{
                                        'form-error': !(number.valid || number.pristine),
                                        'form-success': number.valid
                                     }"
                                   [(ngModel)]="inspectionOrder.number"
                                   #number="ngModel">
                            <i class="fa fa-file"></i>
                            <div [hidden]="number.valid || number.pristine"
                                 class="form-error valid">
                                Inserisci almeno 3 caratteri.
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="referent_name" class="col-sm-3 control-label">Nome Referente</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="text"
                                   id="referent_name"
                                   name="referent_name"
                                   class="form-control"
                                   placeholder="Inserisci Nome Referente..."
                                   minlength="3"
                                   autocomplete="off"
                                   [ngClass]="{
                                        'form-error': !(referent_name.valid || referent_name.pristine),
                                        'form-success': referent_name.valid
                                     }"
                                   [(ngModel)]="inspectionOrder.referent_name"
                                   #referent_name="ngModel">
                            <i class="fa fa-user"></i>
                            <div [hidden]="referent_name.valid || referent_name.pristine"
                                 class="form-error valid">
                                Inserisci almeno 3 caratteri.
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="referent_phone" class="col-sm-3 control-label">Telefono Referente</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="number"
                                   id="referent_phone"
                                   name="referent_phone"
                                   class="form-control"
                                   placeholder="Inserisci Telefono Referente..."
                                   minlength="3"
                                   autocomplete="off"
                                   [ngClass]="{
                                        'form-error': !(referent_phone.valid || referent_phone.pristine),
                                        'form-success': referent_phone.valid
                                     }"
                                   [(ngModel)]="inspectionOrder.referent_phone"
                                   #referent_phone="ngModel">
                            <i class="fa fa-phone"></i>
                            <div [hidden]="referent_phone.valid || referent_phone.pristine"
                                 class="form-error valid">
                                Inserisci almeno 3 caratteri.
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="referent_email" class="col-sm-3 control-label">E-Mail Referente</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="email"
                                   id="referent_email"
                                   name="referent_email"
                                   class="form-control"
                                   placeholder="Inserisci E-Mail Referente..."
                                   minlength="3"
                                   pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$"
                                   autocomplete="off"
                                   [ngClass]="{
                                        'form-error': !(referent_email.valid || referent_email.pristine),
                                        'form-success': referent_email.valid
                                     }"
                                   [(ngModel)]="inspectionOrder.referent_email"
                                   #referent_email="ngModel">
                            <i class="fa fa-at"></i>
                            <div [hidden]="referent_email.valid || referent_email.pristine"
                                 class="form-error valid">
                                Inserisci un'email valida.
                            </div>
                        </div>
                    </div>

                    <div class="text-center m-t-20">
                        <button type="submit"
                                class="btn btn-embossed btn-primary"
                                [disabled]="!inspectionOrderUpdateForm.form.valid">
                            <i class="icon-pencil"></i> Modifica Ordinativo</button>
                    </div>

                    <div [hidden]="inspectionOrderCreationResult" class="alert alert-danger">
                        Si è verificato un errore nella modifica dell'ordinativo, riprovare.
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
